var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBKashIconLogowine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-18.0015 -28.3525 156.013 170.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D12053",
    d: "M96.58 62.45l-53.03-8.31 7.03 31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2136E",
    d: "M96.58 62.45L56.62 6.93 43.56 54.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D12053",
    d: "M42.32 53.51L.45 0l54.83 6.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E1638",
    d: "M23.25 31.15L0 9.24h6.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D12053",
    d: "M107.89 35.46l-9.84 26.69L82.1 40.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2136E",
    d: "M56.77 84.14l38.61-15.51L97 63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E1638",
    d: "M25.89 113.41l16.54-58.02 8.39 37.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2136E",
    d: "M109.43 35.67l-4.06 11.02 14.64-.24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBKashIconLogowine);
export default __webpack_public_path__ + "static/media/BKash-Icon-Logo.wine.bcc558d20fb3e7bb5283a44b1418af4b.svg";
export { ForwardRef as ReactComponent };